<template>
  <v-card>
    <v-progress-linear v-if="loading" indeterminate height="2"></v-progress-linear>
    <template v-if="expert">
      <expert-header :expert="expert" withActions></expert-header>
      <v-tabs grow centered dark scroll-bars>
        <v-divider></v-divider>
        <v-tabs-bar class="grey lighten-5" slot="activators">
          <v-tabs-item
            v-for="tab in tabs" :key="tab.key"
            router
            :href="{ name: 'Expert', params: { id: expert.id, tab: tab.key } }"
            ripple>
            {{ $t(`pages.expert.tabs.${tab.key}`) }}
          </v-tabs-item>
        </v-tabs-bar>
      </v-tabs>
      <v-divider></v-divider>
      <component :is="currentTab.component" :expert="expert"></component>
    </template>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import {
    ExpertHeader,
    ExpertProfile,
    ExpertPurchases,
    ExpertSchedule,
    ExpertConnection
  } from '@/components/expert'
  import Expert from '@/api/currentExpert'
  export default {
    components: {
      ExpertHeader
    },
    props: {
      id: {
        type: Number,
        required: true
      },
      tab: {
        type: String,
        default: () => this.tabs[0].key
      }
    },
    computed: {
      ...mapGetters({
        experts: 'skiliko/experts/collection',
        loading: 'skiliko/experts/isLoading',
        curentUser: 'skiliko/session/currentUser'
      }),
      expert () {
        return this.experts[this.id]
      },
      canEditConnection () {
        if (Expert.isAdmin(this.curentUser)) { return true }
        return this.curentUser.id === this.expert.id
      },
      tabs () {
        return [
          { key: 'profile', component: ExpertProfile },
          this.canEditConnection ? { key: 'connection', component: ExpertConnection } : null,
          { key: 'schedule', component: ExpertSchedule },
          { key: 'purchases', component: ExpertPurchases }
        ].filter(x => x)
      },
      currentTab () {
        return this.tabs.filter(tab => tab.key === this.tab)[0]
      }
    },
    methods: mapActions({
      fetch: 'skiliko/experts/fetch'
    }),
    mounted () {
      this.fetch({ id: this.id })
    }
  }
</script>

<style scoped>
  .progress-linear { margin: 0; }
</style>



// WEBPACK FOOTER //
// src/pages/Expert.vue